import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * FileStack icon
 *
 * @category Files/Forms/Editing
 */
const FileStack = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M26.76 6.412c-.9-1.03-2.248-2.473-3.36-2.981-.876-.379-1.846-.403-2.816-.403-3.975-.283-4.034 1.574-3.951 4.863-.036.97-.414 1.278-1.314 1.313-3.277-.07-5.158 0-4.862 3.904.035 1.266.06 2.414-1.562 2.307-3.241-.165-4.957.32-4.637 3.715v7.252c-.071 1.396.887 2.58 2.366 2.591 1.62.036 4.33.036 6.152 0 2.804.071 2.603-2.685 2.59-4.85.084-3.254 6.378 1.124 6.176-4.449.071-1.313-.402-3.265 1.574-3.076 2.177.06 4.732.095 4.626-2.673-.071-2.39.426-5.928-.84-7.36l-.13-.165zM13.959 27.494c-.958.923-3.597.32-5.064.486-1.195-.119-3.383.508-3.56-1.16-.072-2.603-.13-6.897.011-9.287.284-1.396 2.165-.864 3.526-.982.544.024 1.337-.106 1.455.615.331 1.538-.52 4 .934 5.182.568.473 1.385.462 2.083.556.686.06.863.509.84 1.455-.048 1.183.142 2.13-.142 2.994l-.083.13zm6.353-6.258s-.012.024-.024.035c-.153.213-.45.249-.71.273a42 42 0 0 1-4.2.153c-1.443-.023-3.714.415-3.738-1.573-.035-2.319-.06-4.626-.095-6.945 0-.733-.011-1.49.308-2.141.722-1.467 2.603-.935 3.892-.816.202.023.426.035.592.153.272.178.343.545.367.864.082.982-.095 1.976.035 2.958s.674 2.011 1.633 2.26c.686.189 1.573 0 1.964.59.165.25.177.569.189.865 0 .958-.024 1.904-.095 2.85-.011.155-.023.332-.106.462zm6.294-6.187c-.201.544-.994.58-1.62.544h-6.188c-1.112 0-1.148-.675-1.1-1.716v-2.295c.094-2.141-.202-5.182.13-7.075.236-.508 1.183-.473 1.833-.45 1.183.048 2.189-.141 3.171.178.935.355 2.555 2.177 3.43 3.194.675 1.113.356 2.106.427 3.467-.024 1.218.059 2.97-.036 4.058l-.035.106z"
        />
      </svg>
    );
  }
);

FileStack.displayName = 'FileStack';

export { FileStack };
